import { getShouldBeDisabled } from './helpers/getShouldBeDisabled';
import { getCopayFields } from './helpers/CopayHelpers/getCopayFields';
import { getCopays } from './helpers/CopayHelpers/getCopays';

export function hospitalCopays() {
  return {
    label: 'Hospital Daily Copays',
    isExpanded: !getShouldBeDisabled(this.eligibility.healthCareCopayInfos),
    isDisabled: getShouldBeDisabled(this.eligibility.healthCareCopayInfos),
    bodyComponent: () => ({
      component: import(
        'src/components/FullPatientData/PatientWidgetBody/InsuranceWidgetNew/DetailsModalBody/AccordionBodyTable/AccordionBodyTable'
      ),
    }),
    bodyProps: {
      fields: getCopayFields(),
      data: getCopays(this.eligibility.healthCareCopayInfos),
    },
  };
}
